// extracted by mini-css-extract-plugin
export default {"form":"style_form__m1efp","formInputBlock":"style_formInputBlock__ybCc6","formInputBlock2":"style_formInputBlock2__0vQ-S","formInput":"style_formInput__3EFRp"};